export default __webpack_public_path__ + "static/media/gemleo.5d5a6971.png";